import { useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import {
  Button,
  FormControlLabel,
  Radio,
  RadioGroup,
  Dialog,
  DialogContent,
} from "@mui/material";
import LocalSeeIcon from "@mui/icons-material/LocalSee";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddIcon from "@mui/icons-material/Add";
import { ExpandMore, KeyboardArrowRight } from "@mui/icons-material";
import Select from "react-select";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import baseURL from "../../../../configs/api";
import colorConfigs from "../../../../configs/colorConfigs";

import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import React from "react";
import PleaseWaitPopup from "../../../PleaseWaitPopup";
import axois from "../../../../configs/axois";
import useAuth from "../../../../components/hooks/useAuth";
import { handleCapture } from "../../../../utils/covertTheBase64FormatIntoImage";
import { validateMin } from "../../../../utils/validateMin";
import { getAdditionalCharges } from "../../../../services/additionalCharge";
import { delete_VehicleClassFeatureMappingByVehicleClassId, getVehicleClassFeatureMappingsByVehicleClassId, post_VehicleClassFeatureMapping } from "../../../../services/vehicleClassFeatureMapping";
import CustomFormatDatePicker from "../../../../components/common/CustomFormatDatePicker";
import useGeneral from "../../../../components/hooks/useGeneral";
import { useTheme } from "../../../../components/hooks/useTheme";
import useDelete from "../../../../components/hooks/useDelete";
import useConfirm from "../../../../components/hooks/useConfirm";
import { CustomImagePopup } from "../../../../components/common/CustomImagePopup";
import { put_fileUpload } from "../../../../services/appFileUpload";
import { fuelTypesOption } from "../../../../utils/fuelTypesOption";
import Cookies from "js-cookie";
import useTenant from "../../../../components/hooks/useTenant";

export default function EditVehicleClass() {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles, theme } = useTheme();
  const { auth }: any = useAuth();
  const { handleTenantError }: any = useTenant();
  const { dateFormat }: any = useGeneral();
  const navigate = useNavigate();
  const { setDeletePopup, setData: setDeleteData }: any = useDelete();
  const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
  const [isGeneralSettings, setIsGeneralSettings] = useState<boolean>(true);
  const [isRentalProcess, setIsRentalProcess] = useState<boolean>(true);
  const [isAdvanced, setIsAdvanced] = useState<boolean>(true);
  const [isWebsite, setIsWebsite] = useState<boolean>(true);
  const [branch, setBranch] = useState([]);
  const [name, setName] = useState<string>("");
  const [branchId, setBranchId] = useState<string>("");
  const [availableOnWebsite, setAvailableOnWebsite] = useState<string>("No");
  const [active, setActive] = useState<string>("No");
  const [order, setOrder] = useState<string>("");
  const [calenderOrder, setCalenderOrder] = useState<string>("");
  const [allowedOverbookingQuantity, setAllowedOverbookingQuantity] =
    useState<string>("");
  const [overbookingBackupClassId, setOverbookingBackupClassId] =
    useState<string>("");
  const [minimumRentalAllowedAge, setMinimumRentalAllowedAge] =
    useState<string>("");
  const [maxRentalAllowedAge, setMaxRentalAllowedAge] = useState<string>("");
  const [tankSize, setTankSize] = useState<string>("");
  const [allEngineTypes, setAllEngineTypes] = useState<any[]>([]);
  const [engineType, setEngineType] = useState<string>("");
  const [vehicleHeight, setVehicleHeight] = useState<string>("");
  const [fuel, setFuel] = useState<string>("");
  const [fuelChargeperOneByEight, setFuelChargeperOneByEight] =
    useState<string>("");
  const [allowedRoles, setAllowedRoles] = useState<string>("");
  const [allowedLocations, setAllowedLocations] = useState<string>("");
  const [restrictedLocations, setRestrictedLocations] = useState<string>("");
  const [startDate, setStartDate] = useState<string>("");
  const [spareQuantity, setSpareQuantity] = useState<string>("");
  const [distancelimit, setDistancelimit] = useState<string>("");
  const [distanceLimitperDay, setDistanceLimitperDay] = useState<string>("");
  const [distanceLimitperWeek, setDistanceLimitperWeek] = useState<string>("");
  const [distanceLimitperMonth, setDistanceLimitperMonth] =
    useState<string>("");
  const [additionalChargeOptions, setAdditionalChargeOptions] = useState<any[]>([]);
  const [
    additionalChargeIdforExceededDistance,
    setAdditionalChargeIdforExceededDistance,
  ] = useState<string>("");
  const [
    additionalChargeIdforReturnInDifferentLocation,
    setAdditionalChargeIdforReturnInDifferentLocation,
  ] = useState<string>("");
  const [additionalChargeIdForAdditionalDriver, setAdditionalChargeIdForAdditionalDriver] = useState<string>("");
  const [sipp, setSipp] = useState<string>("");
  const [driverYearsExperience, setDriverYearsExperience] =
    useState<string>("");
  const [enableFuelLevelTracking, setEnableFuelLevelTracking] = useState<string>("No");
  const [enableOdometerTracking, setEnableOdometerTracking] = useState<string>("No");
  const [similarVehicleMakeId, setSimilarVehicleMakeId] = useState<string>("");
  const [similarVehicleModelId, setSimilarVehicleModelId] =
    useState<string>("");
  const [features, setFeatures] = useState<any>();
  const [featuresOptions, setFeaturesOptions] = useState<any[]>([]);
  const [label, setLabel] = useState<string>("");
  const [shortDiscription, setShortDiscription] = useState<string>("");
  const [discription, setDiscription] = useState<string>("");

  const [recommended, setRecommended] = useState<string>("No");
  const [limitedAvailability, setLimitedAvailability] = useState<string>("No");
  const [
    percentageforLimitedAvailability,
    setPercentageForLimitedAvailability,
  ] = useState<string>("");

  const [showWebcam, setShowWebcam] = useState<boolean>(false);
  const [filePath, setFilePath] = useState<string>("");
  const [file, setFile] = useState<FileList | null>(null);
  const [isClone, setIsClone] = useState<boolean>(false);
  const [imagePopup, setImagePopup] = useState<boolean>(false);

  const [websiteShowWebcam, setWebsiteShowWebcam] = useState<boolean>(false);
  const [websiteFilePath, setWebsiteFilePath] = useState<any[]>([]);
  const [fileIndex, setFileIndex] = useState<number>(-1);
  const [websiteImagePopup, setWebsiteImagePopup] = useState<boolean>(false);
  const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);
  const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
  const [disabled, setDisabled] = useState<boolean>(true);
  const [minAgeError, setMinAgeError] = useState("");
  const [maxAgeError, setMaxAgeError] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      const min = Number(minimumRentalAllowedAge);
      const max = Number(maxRentalAllowedAge);

      if (minimumRentalAllowedAge !== "" && maxRentalAllowedAge !== "") {
        if (min > max) {
          setMinAgeError("Minimum age cannot be greater than maximum age.");
          setMaxAgeError("Maximum age cannot be less than minimum age.");
        } else {
          setMinAgeError("");
          setMaxAgeError("");
        }
      } else {
        setMinAgeError("");
        setMaxAgeError("");
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [minimumRentalAllowedAge, maxRentalAllowedAge]);

  useEffect(() => {
    axios
      .get(`${baseURL}vehicleEngine`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setAllEngineTypes(() =>
          response.data.map((item: any) => {
            return {
              value: item.id,
              label: item.engineName
            };
          })
        );
        handleTenantError(null);
      }).catch((error) => {
        handleTenantError(error);
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    axios
      .get(`${baseURL}branch`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then(response => {
        setBranch(
          response.data.map((item: any) => {
            return { value: item.id, label: item.branchName };
          })
        );
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axios
      .get(`${baseURL}Feature`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setFeaturesOptions(() =>
          response.data.map((item: any) => {
            return {
              value: item.id,
              label: item.label
            };
          })
        );

        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getAdditionalCharges(tenantId)
      .then((res) => {
        setAdditionalChargeOptions(
          res.filter((value: any) => !value.hideFromReservations)
            .map((item: any) => {
              return {
                value: item?.id,
                label: item?.name
              }
            })
        )
        handleTenantError(null);
      })
      .catch((error) => handleTenantError(error))

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const idNumber = useLocation();

  useEffect(() => {
    if (isFirstTime) {
      setPleaseWaitPopup(true);
      axios
        .get(`${baseURL}vehicleClass/${idNumber.state}`, {
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
        .then(response => {
          setName(response.data.name);
          setBranchId(response.data.branchId);
          setAvailableOnWebsite(response.data.availableOnWebsite ? "Yes" : "No");
          setActive(response.data.active ? "Yes" : "No");
          setRecommended(response.data.recommended ? "Yes" : "No");
          setOrder(response.data.order);
          setCalenderOrder(response.data.calenderOrder);
          setAllowedOverbookingQuantity(response.data.allowedOverbookingQuantity);
          setOverbookingBackupClassId(response.data.overbookingBackupClassId);
          setMinimumRentalAllowedAge(response.data.minimumRentalAllowedAge);
          setMaxRentalAllowedAge(response.data.maxRentalAllowedAge);
          setTankSize(response.data.tankSize);
          setLimitedAvailability(response.data.limitedAvailability ? "Yes" : "No");
          setPercentageForLimitedAvailability(
            response.data.percentageforLimitedAvailability
          );
          setFuelChargeperOneByEight(response.data.fuelChargeperOneByEight);
          setAllowedRoles(response.data.allowedRoles);
          setAllowedLocations(response.data.allowedLocations);
          setRestrictedLocations(response.data.restrictedLocations);
          setStartDate(response.data.startDate.split("T")[0]);
          setSpareQuantity(response.data.spareQuantity);
          setDistancelimit(response.data.distancelimit);
          setDistanceLimitperDay(response.data.distanceLimitperDay);
          setDistanceLimitperWeek(response.data.distanceLimitperWeek);
          setDistanceLimitperMonth(response.data.distanceLimitperMonth);
          setAdditionalChargeIdforExceededDistance(
            response.data.additionalChargeIdforExceededDistance
          );
          setAdditionalChargeIdforReturnInDifferentLocation(
            response.data.additionalChargeIdforReturnInDifferentLocation
          )
          setAdditionalChargeIdForAdditionalDriver(response.data.additionalChargeIdForAdditionalDriver);
          setSipp(response.data.sipp);
          setDriverYearsExperience(response.data.driverYearsExperience);
          setEnableFuelLevelTracking(response.data.enableFuelLevelTracking ? "Yes" : "No");
          setEnableOdometerTracking(response.data.enableOdometerTracking ? "Yes" : "No");
          setSimilarVehicleMakeId(response?.data?.similarVehicleMakeId ? response?.data?.similarVehicleMakeId : "");
          setSimilarVehicleModelId(response.data.similarVehicleModelId ? response.data.similarVehicleModelId : "");
          setLabel(response.data.label);
          setEngineType(response.data.engineType);
          setVehicleHeight(response.data.vehicleHeight);
          setFuel(response.data.fuel);
          setEditorStateShort(
            EditorState.createWithContent(
              ContentState.createFromBlockArray(
                convertFromHTML(response.data.shortDiscription).contentBlocks,
                convertFromHTML(response.data.shortDiscription).entityMap
              )
            )
          );
          setEditorStateDescription(
            EditorState.createWithContent(
              ContentState.createFromBlockArray(
                convertFromHTML(response.data.discription).contentBlocks,
                convertFromHTML(response.data.discription).entityMap
              )
            )
          );

          if (response.data.imagePath.startsWith("data:image/png;base64,")) {
            setFilePath(response.data.imagePath);
          } else {
            setFilePath(
              `${baseURL}vehicleClassFile/Get?name=${response.data.imagePath}`,
            );
          }

          setIsFirstTime(false);
          setPleaseWaitPopup(false);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    axois
      .get(`${baseURL}fileUploadData/GetFileUploadDatasByAttribute?attributeName=VehicleClass&attributeId=${idNumber.state}`, {
        headers: {
          'X-Tenant-ID': tenantId,
        }
      })
      .then((response) => {
        setWebsiteFilePath(
          response.data
            .map((item: any) => {
              return {
                id: item.id,
                fileName: item.fileName.startsWith("data:image/png;base64,")
                  ? item.fileName
                  : `${baseURL}vehicleClassFile/Get?name=${item.fileName}`,
              };
            })
        );
        if (response.data.length > 0) setFileIndex(0);
        handleTenantError(null);
      })
      .catch((error) => {
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (featuresOptions.length > 0 && !isFirstTime) {
      getVehicleClassFeatureMappingsByVehicleClassId(idNumber?.state, tenantId)
        .then((res) => {
          const selectedFeature = featuresOptions?.filter((_: any) => res?.find((item: any) => item?.featureId === _?.value));
          setFeatures(selectedFeature);
          setIsFirstTime(true);
          handleTenantError(null);
        })
        .catch((error) => {
          setIsFirstTime(true);
          handleTenantError(error);
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featuresOptions, isFirstTime])

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!!minAgeError || !!maxAgeError) return;

    if (!pleaseWaitPopup) {
      if (filePath === "" && file === null) {
        setConfirmData({
          title: 'Warning',
          summary: "Please add an image.",
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);

      } else {
        setPleaseWaitPopup(true);
        if (file === null) {
          if (filePath.startsWith("data:image/png;base64,")) {
            saveVehicleClass(filePath, false)
          } else {
            saveVehicleClass(filePath?.replace(`${baseURL}vehicleClassFile/Get?name=`, ""), false);
          }
        } else {
          const formData = new FormData();
          formData.append("ImageFile", file[0]);

          await axios
            .post(`${baseURL}vehicleClassFile/upload`, formData, {
              headers: {
                'X-Tenant-ID': tenantId,
                "Content-Type": "multipart/form-data"
              },
              withCredentials: true,
            })
            .then(response => {
              saveVehicleClass(response.data, false)
              handleTenantError(null);
            })
            .catch(error => handleTenantError(error));
        }
      }
    }
  };

  const updateFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {

    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;
    if (selectedFiles.length !== 0) {
      const formData = new FormData();
      formData.append("ImageFile", selectedFiles[0]);
      axios
        .post(`${baseURL}vehicleClassFile/upload`, formData, {
          headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "multipart/form-data"
          },
          withCredentials: true,
        })
        .then((response) => {
          setFilePath(`${baseURL}vehicleClassFile/Get?name=${response.data}`)
          setFile(null);
          saveVehicleClass(response.data, true);
          handleTenantError(null);
        })
        .catch((error) => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        });
    } else {
      setPleaseWaitPopup(false);
    }

  }

  const saveVehicleClass = async (fileName: string, fromFileUpdate: boolean) => {
    if (isClone) {
      await axios
        .post(
          `${baseURL}vehicleClass?userId=${auth?.id}`,
          JSON.stringify({
            name,
            branchId,
            imagePath: fileName,
            availableOnWebsite: availableOnWebsite === "Yes",
            active: active === "Yes",
            recommended: recommended === "Yes",
            order,
            calenderOrder,
            allowedOverbookingQuantity,
            overbookingBackupClassId,
            minimumRentalAllowedAge,
            maxRentalAllowedAge,
            tankSize,
            limitedAvailability: limitedAvailability === "Yes",
            percentageforLimitedAvailability,
            fuelChargeperOneByEight,
            allowedRoles,
            allowedLocations,
            restrictedLocations,
            startDate: startDate + "T00:00:00",
            spareQuantity,
            distancelimit,
            distanceLimitperDay,
            distanceLimitperWeek,
            distanceLimitperMonth,
            additionalChargeIdforExceededDistance,
            additionalChargeIdforReturnInDifferentLocation,
            sipp,
            driverYearsExperience,
            enableFuelLevelTracking: enableFuelLevelTracking === "Yes",
            enableOdometerTracking: enableOdometerTracking === "Yes",
            similarVehicleMakeId,
            similarVehicleModelId,
            features: "",
            label,
            shortDiscription,
            discription,
            engineType,
            vehicleHeight,
            fuel
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res?.data) {
            if (features?.length > 0) {
              post_VehicleClassFeatureMapping(
                features?.map((item: any) =>
                ({
                  vehicleClassId: res?.data,
                  featureId: item?.value
                })
                ), auth?.id, tenantId)
                .then(() => {
                  saveWebsiteFile();
                })
                .catch(error => {
                  saveWebsiteFile()
                  console.error("Error:", error);
                })
            } else {
              saveWebsiteFile();
            }
          } else {
            saveWebsiteFile();
          }
          handleTenantError(null);
        })
        .catch(error => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        })
    } else {
      await axios
        .put(
          `${baseURL}vehicleClass?userId=${auth?.id}`,
          JSON.stringify({
            id: idNumber.state,
            name,
            branchId,
            imagePath: fileName,
            availableOnWebsite: availableOnWebsite === "Yes",
            active: active === "Yes",
            recommended: recommended === "Yes",
            order,
            calenderOrder,
            allowedOverbookingQuantity,
            overbookingBackupClassId,
            minimumRentalAllowedAge,
            maxRentalAllowedAge,
            tankSize,
            limitedAvailability: limitedAvailability === "Yes",
            percentageforLimitedAvailability,
            fuelChargeperOneByEight,
            allowedRoles,
            allowedLocations,
            restrictedLocations,
            startDate: startDate + "T00:00:00",
            spareQuantity,
            distancelimit,
            distanceLimitperDay,
            distanceLimitperWeek,
            distanceLimitperMonth,
            additionalChargeIdforExceededDistance,
            additionalChargeIdforReturnInDifferentLocation,
            additionalChargeIdForAdditionalDriver,
            sipp,
            driverYearsExperience,
            enableFuelLevelTracking: enableFuelLevelTracking === "Yes",
            enableOdometerTracking: enableOdometerTracking === "Yes",
            similarVehicleMakeId,
            similarVehicleModelId,
            features: "",
            label,
            shortDiscription,
            discription,
            engineType,
            vehicleHeight,
            fuel
          }),
          {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "application/json"
            },
            withCredentials: true,
          }
        )
        .then((res) => {
          if (res?.data) {
            delete_VehicleClassFeatureMappingByVehicleClassId(res?.data, auth?.id, tenantId)
              .then(() => {
                if (features?.length > 0) {
                  post_VehicleClassFeatureMapping(
                    features?.map((item: any) =>
                    ({
                      vehicleClassId: res?.data,
                      featureId: item?.value
                    })
                    ), auth?.id, tenantId)
                    .then(() => {
                      handleTenantError(null);
                      saveWebsiteFile(fromFileUpdate);
                    })
                    .catch(error => {
                      saveWebsiteFile(fromFileUpdate);
                      handleTenantError(error);
                    })
                } else {
                  saveWebsiteFile(fromFileUpdate);
                }
                handleTenantError(null);
              })
              .catch(error => {
                saveWebsiteFile(fromFileUpdate);
                handleTenantError(error);
              });
          } else {
            saveWebsiteFile(fromFileUpdate);
          }
          handleTenantError(null);
        })
        .catch(error => {
          setPleaseWaitPopup(false);
          handleTenantError(error);
        })
    }
  }

  const saveWebsiteFile = (fromFileUpdate: boolean = false) => {
    if (websiteFilePath.length > 0) {
      let count = 0;
      if (websiteFilePath.filter(item => item.id === 0).length > 0) {
        websiteFilePath.filter(item => item.id === 0)
          .forEach(async (item: any, _: number, arr: any[]) => {
            await axios
              .post(
                `${baseURL}fileUploadData?userId=${auth?.id}`,
                JSON.stringify({
                  attributeName: "VehicleClass",
                  attributeId: idNumber.state,
                  fileName: item.fileName?.replace(`${baseURL}vehicleClassFile/Get?name=`, ""),
                  tabName: "VehicleClass",
                  userId: auth?.id,
                  createdDate: new Date(),
                }),
                {
                  headers: {
                    'X-Tenant-ID': tenantId,
                    "Content-Type": "application/json"
                  },
                  withCredentials: true,
                }
              )
              .then(() => {
                count++;
                if (arr.length === count) {
                  setPleaseWaitPopup(false);
                  if (!fromFileUpdate) navigate(-1);
                }
                handleTenantError(null);
              })
              .catch(error => handleTenantError(error));
          });
      } else {
        setPleaseWaitPopup(false);
        if (!fromFileUpdate) navigate(-1);
      }
    } else {
      setPleaseWaitPopup(false);
      if (!fromFileUpdate) navigate(-1);
    }
  }

  const deleteVehicleClass = () => {
    setDeleteData({
      id: idNumber,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Vehicle Class?`,
      isDelete: (callback: any) => {
        setPleaseWaitPopup(true);

        fetch(`${baseURL}vehicleClass?id=${idNumber?.state}&userId=${auth?.id}`, {
          method: 'DELETE',
          headers: {
            'X-Tenant-ID': tenantId,
          }
        })
          .then(() => {
            setPleaseWaitPopup(false);
            navigate(-1);
            callback();
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            callback();
            handleTenantError(error);
          });
      }
    });

    setDeletePopup(true);
  };

  const webRef = useRef(null);
  const inputFileRef = useRef<HTMLInputElement>(null);
  const onFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles && selectedFiles.length > 0) {
      const file = selectedFiles[0];
      const fileName = file.name.toLowerCase();

      const supportedExtensions = ['.jpg', '.jpeg', '.png', '.heif'];

      const isSupported = supportedExtensions.some(ext => fileName.endsWith(ext));

      if (isSupported) {
        setFilePath("");
        setFile(selectedFiles);
      } else {
        console.error('Unsupported file type');
        setConfirmData({
          title: 'Warning',
          summary: "Unsupported file type",
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);
      }
    }
  };


  const inputWebsiteFileRef = useRef<HTMLInputElement>(null);
  const onWebsiteFileChangeCapture = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;

    if (selectedFiles && selectedFiles.length > 0) {
      const file = selectedFiles[0];
      const fileName = file.name.toLowerCase();

      const supportedExtensions = ['.jpg', '.jpeg', '.png', '.heif'];

      const isSupported = supportedExtensions.some(ext => fileName.endsWith(ext));

      if (isSupported) {
        const formData = new FormData();
        formData.append("ImageFile", selectedFiles[0]);

        axios
          .post(`${baseURL}vehicleClassFile/upload`, formData, {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "multipart/form-data"
            },
            withCredentials: true,
          })
          .then((response) => {
            const file: any = {
              id: 0,
              fileName: `${baseURL}vehicleClassFile/Get?name=${response.data}`
            };
            setWebsiteFilePath(prevPath => [...prevPath, file]);
            setPleaseWaitPopup(false);
            handleTenantError(null);
          })
          .catch((error) => {
            handleTenantError(error);
          });
      } else {
        setPleaseWaitPopup(false);
        console.error('Unsupported file type');

        setConfirmData({
          title: 'Warning',
          summary: "Unsupported file type",
          confirmBtn: 'Ok',
          isConfirm: (callback: any) => {
            callback();
          }
        });

        setConfirmPopup(true);
      }
    }
  };

  const updateWebsiteFile = (e: React.ChangeEvent<HTMLInputElement>, id: number) => {

    setPleaseWaitPopup(true);
    const selectedFiles = e.target.files as FileList;
    if (selectedFiles && selectedFiles.length > 0) {
      const file = selectedFiles[0];
      const fileName = file.name.toLowerCase();

      const supportedExtensions = ['.jpg', '.jpeg', '.png', '.heif'];

      const isSupported = supportedExtensions.some(ext => fileName.endsWith(ext));

      if (isSupported) {
        const formData = new FormData();
        formData.append("ImageFile", selectedFiles[0]);
        axios
          .post(`${baseURL}vehicleClassFile/upload`, formData, {
            headers: {
              'X-Tenant-ID': tenantId,
              "Content-Type": "multipart/form-data"
            },
            withCredentials: true,
          })
          .then((response) => {

            put_fileUpload({
              id,
              attributeName: "VehicleClass",
              attributeId: idNumber.state,
              fileName: response.data,
              tabName: "VehicleClass",
              userId: auth?.id ?? 0,
              createdDate: new Date()
            }, auth?.id, tenantId)
              .then(() => {
                setWebsiteFilePath((prevPath: any[]) =>
                  prevPath.map(file =>
                    file.id === id ? {
                      ...file, fileName: `${baseURL}vehicleClassFile/Get?name=` +
                        response.data,
                    } : file
                  )
                );
                setPleaseWaitPopup(false);
                handleTenantError(null);
              })
              .catch((error) => {
                const errorMessage = error?.response?.data?.message || error?.message || "File upload failed.";
                setConfirmData({
                  title: 'Warning',
                  summary: errorMessage,
                  confirmBtn: 'Ok',
                  isConfirm: (callback: any) => {
                    callback();
                  }
                });
                setConfirmPopup(true);
                setPleaseWaitPopup(false);
                handleTenantError(error);
              })
            handleTenantError(null);
          })
          .catch((error) => {
            setPleaseWaitPopup(false);
            handleTenantError(error);
          });
      } else {
        setPleaseWaitPopup(false);
      }
    }
  }

  const handleDeleteImage = () => {
    setDeleteData({
      id: 0,
      tilte: `Delete`,
      summary: `Are you sure you want to delete this Image?`,
      isDelete: async (callback: any) => {
        if (inputFileRef.current) {
          inputFileRef.current.value = '';
        }
        setFile(null);
        setFilePath("");

        callback();
      }
    });

    setDeletePopup(true);
  }

  const [editorStateShort, setEditorStateShort] = useState(() =>
    EditorState.createEmpty()
  );
  const [editorStateDescription, setEditorStateDescription] = useState(() =>
    EditorState.createEmpty()
  );

  useEffect(() => {
    setShortDiscription(
      draftToHtml(convertToRaw(editorStateShort.getCurrentContent()))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editorStateShort]);

  useEffect(() => {
    setDiscription(
      draftToHtml(convertToRaw(editorStateDescription.getCurrentContent()))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editorStateDescription]);

  const handleEdit = () => {
    setDisabled(false);
    setShowWebcam(false);
    setWebsiteShowWebcam(false);
  };

  return (
    <>
      <div className={`px-[24px] py-[20px] min-h-screen h-full ${themeStyles.main.tailwindSectionBg}`}>
        <div className={`w-full ${themeStyles.main.tailwindMainBg} rounded-lg p-[10px] pb-[40px] flex flex-col gap-2.51`}>
          <div className="w-full mt-2">
            <div className={`w-full pb-4`}>

              <div className={`flex justify-between items-center p-2 border-b ${themeStyles.main.borderColor}`}>
                <div className="flex items-center gap-1.5">
                  <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Edit  Vehicle Class</h2>
                </div>
                <div className="flex items-center gap-1.5">
                  {
                    !isClone && (
                      <button className={`px-[12px] py-[10px] ${colorConfigs.btn.main.tailwind} shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                        onClick={() => {
                          setIsClone(true)
                          setDisabled(false);
                        }
                        }
                      >
                        <span className="text-xs font-medium">Clone Vehicle Class</span>
                      </button>
                    )
                  }
                  {
                    disabled && (
                      <button className={`px-[8px] py-[6px] bg-transparent shadow-sm rounded-lg border ${themeStyles.main.borderColor} text-white flex items-center gap-1.5`}
                        onClick={handleEdit}
                      >
                        <span className={`material-symbols-outlined text-[25px] font-light ${themeStyles.main.textSubHeadingColor}`}>
                          edit
                        </span>
                        <span className={`text-xs font-medium ${themeStyles.main.textSubHeadingColor}`}>Edit</span>
                      </button>
                    )
                  }
                </div>
              </div>

              <div className="w-3/4 mt-2 p-2">
                <form onSubmit={(e) => handleSubmit(e)}>
                  <h5
                    className="mb-0 flex items-center cursor-pointer select-none"
                    onClick={() => setIsGeneralSettings(!isGeneralSettings)}
                  >
                    {isGeneralSettings ? (
                      <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    ) : (
                      <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                    )}
                    <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                      General
                    </div>
                  </h5>
                  <hr />

                  <div className="w-full px-2 mt-1.5">
                    {isGeneralSettings &&
                      <div className="grid grid-cols-2 gap-6">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Name</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={name}
                              disabled={disabled}
                              onChange={(e) => setName(e.target.value)}
                              required
                            />
                          </div>

                          <div style={{ marginTop: "10px" }}>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Images</label>
                            <br />
                            {(file || filePath) && (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                {file && (
                                  <img
                                    src={URL.createObjectURL(file[0])}
                                    width={40}
                                    height={40}
                                    alt="vehicle"
                                    onClick={() => setImagePopup(true)}
                                  />
                                )}

                                {filePath && (
                                  <img
                                    src={filePath}
                                    width={40}
                                    height={40}
                                    alt="vehicle"
                                    onClick={() => setImagePopup(true)}
                                  />
                                )}

                                <RemoveCircleIcon
                                  sx={{
                                    fontSize: "14px",
                                    color: colorConfigs.topbar.bg,
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                    "&: hover": {
                                      color: "red",
                                    },
                                  }}
                                  onClick={handleDeleteImage}
                                />
                              </div>
                            )}
                            <input
                              type="file"
                              accept="image/*"
                              ref={inputFileRef}
                              disabled={disabled}
                              onChangeCapture={onFileChangeCapture}
                              style={{ display: "none" }}
                            />
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                gap: "8px",
                                marginTop: "8px",
                              }}
                            >
                              <p
                                style={{
                                  border: "1px dashed black",
                                  borderRadius: "3px",
                                  padding: "3px 5px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "12px",
                                  backgroundColor: "white",
                                }}
                                onClick={(e) => {
                                  if (inputFileRef.current !== null) {
                                    inputFileRef.current.value = "";
                                  }
                                  inputFileRef.current?.click();
                                }}
                              >
                                {" "}
                                <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                                Add Image
                              </p>

                              <p
                                style={{
                                  border: "1px dashed black",
                                  borderRadius: "3px",
                                  padding: "3px 5px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontSize: "12px",
                                  backgroundColor: "white",
                                }}
                                onClick={() => setShowWebcam(true)}
                              >
                                {" "}
                                <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Branch</label>
                            <select
                              className={`w-full px-[8px] py-[10px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={branchId}
                              disabled={disabled}
                              onChange={(e) => setBranchId(e.target.value)}
                            >
                              {branch?.map((role: any, index: number) => (
                                <option key={index} value={role.value}>
                                  {role.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsRentalProcess(!isRentalProcess)}
                    >
                      {isRentalProcess ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Rental Process
                      </div>
                    </h5>
                    <hr />

                    {isRentalProcess &&
                      <div className="grid grid-cols-2 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Available on Website?</label>
                            <RadioGroup
                              row
                              value={availableOnWebsite}
                              onChange={(e) => setAvailableOnWebsite(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Recommended?</label>
                            <RadioGroup
                              row
                              value={recommended}
                              onChange={(e) => setRecommended(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Order</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={order}
                              disabled={disabled}
                              onChange={(e) => setOrder(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allowed Overbooking Quantity</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={allowedOverbookingQuantity}
                              disabled={disabled}
                              onChange={(e) =>
                                setAllowedOverbookingQuantity(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Minimum Rental Allowed Age</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={minimumRentalAllowedAge}
                              disabled={disabled}
                              onChange={(e) =>
                                setMinimumRentalAllowedAge(e.target.value)
                              }
                              required
                            />
                            {minAgeError && <p className="text-red-500 text-sm mt-1">{minAgeError}</p>}
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Tank Size {`(Gallon/Liter)`}</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={tankSize}
                              disabled={disabled}
                              onChange={(e) => setTankSize(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Engine Type</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={engineType}
                              onChange={(e) => setEngineType(e.target.value)}
                              required
                              disabled={disabled}
                            >
                              {
                                allEngineTypes?.map((item: any, index: number) => (
                                  <option key={index} className={`${themeStyles.main.tailwindSectionBg}`} value={item.value}>{item.label}</option>
                                ))
                              }

                            </select>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fuel</label>
                            <select
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={fuel}
                              onChange={(e) => setFuel(e.target.value)}
                              required
                              disabled={disabled}
                            >
                              {
                                fuelTypesOption.map((item: any, index: number) => (
                                  <option className={`${themeStyles.main.tailwindSectionBg}`} value={item.value}>{item.label}</option>
                                ))
                              }

                            </select>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Active?</label>
                            <RadioGroup
                              row
                              value={active}
                              onChange={(e) => setActive(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Limited Availability</label>
                            <RadioGroup
                              row
                              value={limitedAvailability}
                              onChange={(e) => setLimitedAvailability(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Calendar Order</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={calenderOrder}
                              disabled={disabled}
                              onChange={(e) => setCalenderOrder(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Overbooking Backup Class</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={overbookingBackupClassId}
                              disabled={disabled}
                              onChange={(e) =>
                                setOverbookingBackupClassId(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Maximum Rental Allowed Age</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={maxRentalAllowedAge}
                              disabled={disabled}
                              onChange={(e) => setMaxRentalAllowedAge(validateMin(e.target.value, 0).toString())}
                              required
                            />
                            {maxAgeError && <p className="text-red-500 text-sm mt-1">{maxAgeError}</p>}
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Fuel Charge per 1/8</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={fuelChargeperOneByEight}
                              disabled={disabled}
                              onChange={(e) =>
                                setFuelChargeperOneByEight(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Percentage for Limited Availability</label>
                            <input
                              type="number"
                              min={0}
                              step={0.01}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={percentageforLimitedAvailability}
                              disabled={disabled}
                              onChange={(e) =>
                                setPercentageForLimitedAvailability(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Vehicle Height</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={vehicleHeight}
                              disabled={disabled}
                              onChange={(e) =>
                                setVehicleHeight(e.target.value)
                              }
                              required
                            />
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsAdvanced(!isAdvanced)}
                    >
                      {isAdvanced ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Advanced
                      </div>
                    </h5>
                    <hr />

                    {isAdvanced &&
                      <div className="grid grid-cols-2 gap-6 mt-2">
                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allowed Roles</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={allowedRoles}
                              disabled={disabled}
                              onChange={(e) =>
                                setAllowedRoles(e.target.value)
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Allowed Locations</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={allowedLocations}
                              disabled={disabled}
                              onChange={(e) =>
                                setAllowedLocations(e.target.value)
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Start Date</label>
                            <CustomFormatDatePicker
                              value={startDate}
                              onChange={setStartDate}
                              dateFormat={dateFormat}
                              disabled={disabled}
                              required={true}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Distance Limit per Hour</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={distancelimit}
                              disabled={disabled}
                              onChange={(e) => setDistancelimit(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Distance Limit per Day</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={distanceLimitperDay}
                              disabled={disabled}
                              onChange={(e) => setDistanceLimitperDay(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Distance Limit per Month</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={distanceLimitperMonth}
                              disabled={disabled}
                              onChange={(e) =>
                                setDistanceLimitperMonth(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>SIPP Code</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={sipp}
                              disabled={disabled}
                              onChange={(e) => setSipp(e.target.value)}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Driver Years Experience</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={driverYearsExperience}
                              disabled={disabled}
                              onChange={(e) =>
                                setDriverYearsExperience(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Enable Fuel Level Tracking</label>
                            <RadioGroup
                              row
                              value={enableFuelLevelTracking}
                              onChange={(e) => setEnableFuelLevelTracking(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <div>
                            <label className={`text-xs font-medium invisible ${themeStyles.form.tailwindLabelTextColor}`}>Allowed Roles</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md invisible ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Restricted Locations</label>
                            <input
                              type="text"
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={restrictedLocations}
                              disabled={disabled}
                              onChange={(e) =>
                                setRestrictedLocations(e.target.value)
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Spare Quantity</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={spareQuantity}
                              disabled={disabled}
                              onChange={(e) => setSpareQuantity(validateMin(e.target.value, 0).toString())}
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Distance Limit per Week</label>
                            <input
                              type="number"
                              min={0}
                              className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                              value={distanceLimitperWeek}
                              disabled={disabled}
                              onChange={(e) =>
                                setDistanceLimitperWeek(validateMin(e.target.value, 0).toString())
                              }
                              required
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Additional Charge for Exceeded Distance</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={disabled}
                              isLoading={false}
                              required
                              isClearable={true}
                              isRtl={false}
                              isSearchable={true}
                              value={additionalChargeOptions.find(option => option.value === additionalChargeIdforExceededDistance)}
                              options={additionalChargeOptions}
                              onChange={(selectedOption) => setAdditionalChargeIdforExceededDistance(selectedOption ? selectedOption.value : '')}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Additional Charge for Return In Different Location</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={disabled}
                              isLoading={false}
                              isClearable={true}
                              required
                              isRtl={false}
                              isSearchable={true}
                              value={additionalChargeOptions.find(option => option.value === additionalChargeIdforReturnInDifferentLocation)}
                              options={additionalChargeOptions}
                              onChange={(selectedOption) => setAdditionalChargeIdforReturnInDifferentLocation(selectedOption ? selectedOption.value : '')}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Additional Charge for Additional Driver</label>
                            <Select
                              styles={{
                                control: (baseStyles, state) => ({
                                  ...baseStyles,
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                  borderRadius: '8px',
                                  borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                  "&: hover": {
                                    borderColor: "#167AC3",
                                  }

                                }),
                                menu: (base) => ({
                                  ...base,
                                  fontSize: "12px",
                                  backgroundColor: themeStyles.topBar.bg,
                                  color: themeStyles.topBar.textColor,
                                }),
                                option: (base, state) => {
                                  const isSelected = state.isSelected;
                                  const isFocused = state.isFocused;
                                  const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                  const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                  const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                  return {
                                    ...base,
                                    backgroundColor: isSelected
                                      ? selectedBg
                                      : isFocused
                                        ? hoverBg
                                        : "transparent",
                                    color: isSelected ? "#fff" : defaultTextColor,
                                    fontWeight: 600,
                                    ':active': {
                                      backgroundColor: isSelected ? selectedBg : hoverBg,
                                    },
                                  };
                                },
                                input: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,

                                }),
                                singleValue: (base) => ({
                                  ...base,
                                  color: themeStyles.topBar.textColor,
                                }),
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isDisabled={disabled}
                              isLoading={false}
                              isClearable={true}
                              required
                              isRtl={false}
                              isSearchable={true}
                              value={additionalChargeOptions.find(option => option.value === additionalChargeIdForAdditionalDriver)}
                              options={additionalChargeOptions}
                              onChange={(selectedOption) => setAdditionalChargeIdForAdditionalDriver(selectedOption ? selectedOption.value : '')}
                            />
                          </div>

                          <div>
                            <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Enable Odometer Tracking</label>
                            <RadioGroup
                              row
                              value={enableOdometerTracking}
                              onChange={(e) => setEnableOdometerTracking(e.target.value)}
                            >
                              <FormControlLabel
                                value="Yes" control=
                                {<Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="Yes"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                              <FormControlLabel value="No" control={
                                <Radio
                                  disabled={disabled}
                                  sx={{
                                    color: "gray",
                                    "&.Mui-checked": { color: "#167AC3" },
                                    "&.Mui-disabled": { color: themeStyles.form.labelTextColor },
                                    "&.Mui-disabled.Mui-checked": { color: "#167AC3" },
                                  }}
                                />} label="No"
                                sx={{
                                  "& .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                  "&.Mui-disabled .MuiFormControlLabel-label": {
                                    color: themeStyles.form.labelTextColor,
                                  },
                                }}
                              />
                            </RadioGroup>
                          </div>
                        </div>
                      </div>
                    }

                    <h5
                      className="mb-0 mt-4 flex items-center cursor-pointer select-none"
                      onClick={() => setIsWebsite(!isWebsite)}
                    >
                      {isWebsite ? (
                        <ExpandMore sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      ) : (
                        <KeyboardArrowRight sx={{ fontSize: "20px", color: themeStyles.topBar.textColor }} />
                      )}
                      <div className="ml-1" style={{ color: themeStyles.topBar.textColor }}>
                        Website
                      </div>
                    </h5>
                    <hr />

                    {isWebsite &&
                      <>
                        <div className="grid grid-cols-2 gap-6 mt-2">
                          <div className="space-y-4">
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Similar Vehicle Make</label>
                              <input
                                type="number"
                                min={0}
                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                value={similarVehicleMakeId}
                                disabled={disabled}
                                onChange={(e) =>
                                  setSimilarVehicleMakeId(validateMin(e.target.value, 0).toString())
                                }
                              />
                            </div>

                            <div style={{ marginTop: "10px" }}>
                              <label
                                htmlFor="image"
                                className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}
                              >
                                Website Images
                                <br />
                                <div
                                  style={{
                                    maxWidth: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    gap: "5px",
                                    flexWrap: "wrap"
                                  }}
                                >
                                  {websiteFilePath.map((item: any, outerIndex: number) => {
                                    return (
                                      <React.Fragment key={outerIndex}>
                                        <img
                                          src={item.fileName}
                                          width={40}
                                          height={40}
                                          alt="Vehcile Class"
                                          onClick={() => {
                                            setFileIndex(outerIndex);
                                            setWebsiteImagePopup(true);
                                          }}
                                        />
                                        <RemoveCircleIcon
                                          sx={{
                                            fontSize: "14px",
                                            color: colorConfigs.topbar.bg,
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                            "&: hover": {
                                              color: "red",
                                            },
                                          }}
                                          onClick={() => {
                                            setDeleteData({
                                              id: 0,
                                              tilte: `Delete`,
                                              summary: `Are you sure you want to delete this image?`,
                                              isDelete: (callback: any) => {
                                                setPleaseWaitPopup(true);

                                                if (websiteFilePath[outerIndex].id === 0) {
                                                  setWebsiteFilePath(websiteFilePath.filter((_, index: number) => index !== outerIndex));
                                                  setPleaseWaitPopup(false);
                                                  callback();
                                                } else {
                                                  axios
                                                    .delete(`${baseURL}fileUploadData?id=${websiteFilePath[outerIndex].id}&userId=${auth?.id}`)
                                                    .then(() => {
                                                      setWebsiteFilePath(websiteFilePath.filter((_, index: number) => index !== outerIndex));
                                                      setPleaseWaitPopup(false);
                                                      callback();
                                                    })
                                                    .catch(error => {
                                                      setPleaseWaitPopup(false);
                                                      callback()
                                                      console.error("Error:", error);
                                                    });
                                                }
                                              }
                                            });

                                            setDeletePopup(true);

                                            if (inputWebsiteFileRef.current) {
                                              inputWebsiteFileRef.current.value = "";
                                            }
                                          }}
                                        />
                                      </React.Fragment>
                                    );
                                  })}

                                  <input
                                    type="file"
                                    accept="image/*"
                                    name="inputWebsiteFileRef"
                                    ref={inputWebsiteFileRef}
                                    disabled={disabled}
                                    onChangeCapture={onWebsiteFileChangeCapture}
                                    style={{ display: "none" }}
                                  />
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    gap: "8px",
                                    marginTop: "8px",
                                  }}
                                >
                                  <p
                                    style={{
                                      border: "1px dashed black",
                                      borderRadius: "3px",
                                      padding: "3px 5px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      fontSize: "12px",
                                      backgroundColor: "white",
                                      cursor: "pointer"
                                    }}
                                    onClick={(e) => {
                                      if (inputWebsiteFileRef.current !== null) {
                                        inputWebsiteFileRef.current.value = "";
                                      }
                                      inputWebsiteFileRef.current?.click();
                                    }}
                                  >
                                    {" "}
                                    <AddIcon className="text-[#167AC3] text-[14px] font-bold" />
                                    Add Image
                                  </p>

                                  <p
                                    style={{
                                      border: "1px dashed black",
                                      borderRadius: "3px",
                                      padding: "3px 5px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      fontSize: "12px",
                                      backgroundColor: "white",
                                      cursor: "pointer"
                                    }}
                                    onClick={() => setWebsiteShowWebcam(true)}
                                  >
                                    {" "}
                                    <LocalSeeIcon className="text-[#167AC3] text-[14px] font-bold" />
                                  </p>
                                </div>
                              </label>
                            </div>
                          </div>

                          <div className="space-y-4">
                            <div>
                              <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Similar Vehicle Model</label>
                              <input
                                type="number"
                                min={0}
                                className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                                value={similarVehicleModelId}
                                disabled={disabled}
                                onChange={(e) =>
                                  setSimilarVehicleModelId(validateMin(e.target.value, 0).toString())
                                }
                              />
                            </div>
                          </div>
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Features</label>
                          <Select
                            menuPortalTarget={document.body}
                            styles={{
                              control: (baseStyles, state) => ({
                                ...baseStyles,
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                                borderRadius: '8px',
                                borderColor: state.isFocused ? "#167AC3" : themeStyles.topBar.borderColor,
                                "&: hover": {
                                  borderColor: "#167AC3",
                                }

                              }),
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 9999
                              }),
                              menu: (base) => ({
                                ...base,
                                fontSize: "12px",
                                backgroundColor: themeStyles.topBar.bg,
                                color: themeStyles.topBar.textColor,
                              }),
                              option: (base, state) => {
                                const isSelected = state.isSelected;
                                const isFocused = state.isFocused;
                                const selectedBg = themeStyles.topBar.menuItemsColor || "#167AC3";
                                const hoverBg = themeStyles.topBar.menuItemsHoverColor || "#E6F0FA";
                                const defaultTextColor = themeStyles.topBar.textColor || "#000";

                                return {
                                  ...base,
                                  backgroundColor: isSelected
                                    ? selectedBg
                                    : isFocused
                                      ? hoverBg
                                      : "transparent",
                                  color: isSelected ? "#fff" : defaultTextColor,
                                  fontWeight: 600,
                                  ':active': {
                                    backgroundColor: isSelected ? selectedBg : hoverBg,
                                  },
                                };
                              },
                              input: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,

                              }),
                              singleValue: (base) => ({
                                ...base,
                                color: themeStyles.topBar.textColor,
                              }),
                            }}
                            isMulti
                            className="basic-single"
                            classNamePrefix="select"
                            isDisabled={disabled}
                            isLoading={false}
                            isClearable={true}
                            isRtl={false}
                            isSearchable={false}
                            name="features"
                            value={features}
                            onChange={setFeatures}
                            options={featuresOptions}
                            required
                          />
                        </div>

                        <div>
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Label</label>
                          <input
                            type="text"
                            className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            value={label}
                            disabled={disabled}
                            onChange={(e) =>
                              setLabel(e.target.value)
                            }
                            required
                          />
                        </div>

                        <div
                          className="quill-wrapper my-2"
                          style={{
                            ...(theme === 'dark' && {
                              '--quill-text-color': '#ffffff',
                              '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                            }),
                          } as React.CSSProperties}
                        >
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Short Description</label>
                          <Editor
                            editorState={editorStateShort}
                            wrapperClassName="wrapper-class"
                            editorClassName={`editor-class border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            toolbarClassName="toolbar-class"
                            readOnly={disabled}
                            onEditorStateChange={setEditorStateShort}
                            toolbar={{
                              inline: { inDropdown: false },
                              list: { inDropdown: true },
                              textAlign: { inDropdown: true },
                              link: { inDropdown: true },
                              history: { inDropdown: true },
                            }}
                          />
                        </div>

                        <div
                          className="quill-wrapper mt-8 mb-2"
                          style={{
                            ...(theme === 'dark' && {
                              '--quill-text-color': '#ffffff',
                              '--quill-bg-color': themeStyles.main?.mainBg || '#121212',
                            }),
                          } as React.CSSProperties}
                        >
                          <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Description</label>
                          <Editor
                            editorState={editorStateDescription}
                            wrapperClassName="wrapper-class"
                            editorClassName={`editor-class border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                            toolbarClassName="toolbar-class"
                            readOnly={disabled}
                            onEditorStateChange={setEditorStateDescription}
                            toolbar={{
                              inline: { inDropdown: false },
                              list: { inDropdown: true },
                              textAlign: { inDropdown: true },
                              link: { inDropdown: true },
                              history: { inDropdown: true },
                            }}
                          />
                        </div>
                      </>
                    }

                    <div className="flex gap-4 mt-6">
                      {
                        !disabled && (
                          <Button
                            variant="contained"
                            sx={{
                              backgroundColor: colorConfigs.btn.main.bg,
                              '&.Mui-disabled': {
                                backgroundColor: '#ccc',
                                color: '#666',
                              },
                            }}
                            type="submit"
                            disabled={!!minAgeError || !!maxAgeError}
                          >
                            Save
                          </Button>
                        )
                      }

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.cancel.bg,
                          border: colorConfigs.btn.cancel.border,
                          color: colorConfigs.btn.cancel.color
                        }}
                        onClick={() => navigate(-1)}
                      >
                        Cancel
                      </Button>

                      <Button variant="contained"
                        sx={{
                          backgroundColor: colorConfigs.btn.delete.bg,
                        }}
                        onClick={deleteVehicleClass}
                      >
                        Delete
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div >
      </div>

      <Dialog
        open={showWebcam && !disabled}
        maxWidth="md"
        fullScreen={false}
        PaperProps={{
          style: {
            marginTop: "-16%",
          },
        }}
      >
        <DialogContent sx={{ padding: "0px" }}>
          <Webcam
            width={480}
            height={320}
            ref={webRef}
            screenshotFormat="image/png"
            audio={false}
            disabled={disabled}
          />

          <div
            style={{
              width: "100%",
              height: "50px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingBlock: "8px",
              paddingLeft: "16px",
              paddingRight: "16px",
              backgroundColor: "#eeeeee",
            }}
          >
            <div style={{ width: "50%" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: colorConfigs.btn.cancel.bg,
                  border: colorConfigs.btn.cancel.border,
                  color: colorConfigs.btn.cancel.color
                }}
                onClick={() => setShowWebcam(false)}
              >
                Cancel
              </Button>
            </div>

            <div
              style={{
                width: "50%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: colorConfigs.topbar.bg,
                  color: "white",
                  border: "none",
                  textTransform: "capitalize",
                  fontSize: "12px",
                  "&: hover": {
                    backgroundColor: colorConfigs.topbar.bg,
                    color: "white",
                  },
                }}
                onClick={() => {
                  if (webRef.current !== null) {
                    setFile(null);
                    //@ts-ignore
                    const imageSrc = webRef.current.getScreenshot();

                    handleCapture(imageSrc, `${baseURL}vehicleClassFile/upload`, tenantId, (imageFilePath: string) => {
                      if (imageFilePath) {
                        setFile(null);
                        setFilePath(`${baseURL}vehicleClassFile/Get?name=${imageFilePath}`);
                      }
                    })

                    setShowWebcam(false);
                  }
                }}
              >
                Capture an Image
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <CustomImagePopup
        showPopup={imagePopup}
        handlePopup={() => setImagePopup(false)}
        filePath={file ? URL.createObjectURL(file[0]) : filePath}
        imageBaseUrlPath="vehicleClassFile"
        updateFile={updateFile}

      />


      <Dialog
        open={websiteShowWebcam && !disabled}
        maxWidth="md"
        fullScreen={false}
        PaperProps={{
          style: {
            marginTop: "-16%",
          },
        }}
      >
        <DialogContent sx={{ padding: "0px" }}>
          <Webcam
            width={480}
            height={320}
            ref={webRef}
            screenshotFormat="image/png"
            audio={false}
            disabled={disabled}
          />

          <div
            style={{
              width: "100%",
              height: "50px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              paddingBlock: "8px",
              paddingLeft: "16px",
              paddingRight: "16px",
              backgroundColor: "#eeeeee",
            }}
          >
            <div style={{ width: "50%" }}>
              <Button
                variant="contained"
                style={{
                  backgroundColor: colorConfigs.btn.cancel.bg,
                  border: colorConfigs.btn.cancel.border,
                  color: colorConfigs.btn.cancel.color
                }}
                onClick={() => setWebsiteShowWebcam(false)}
              >
                Cancel
              </Button>
            </div>

            <div
              style={{
                width: "50%",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: colorConfigs.topbar.bg,
                  color: "white",
                  border: "none",
                  textTransform: "capitalize",
                  fontSize: "12px",
                  "&: hover": {
                    backgroundColor: colorConfigs.topbar.bg,
                    color: "white",
                  },
                }}
                onClick={() => {
                  if (webRef.current !== null) {
                    //@ts-ignore
                    const imageSrc = webRef.current.getScreenshot();

                    handleCapture(imageSrc, `${baseURL}vehicleClassFile/upload`, tenantId, (imageFilePath: string) => {
                      if (imageFilePath) {
                        setFile(null);

                        setWebsiteFilePath(prevFilePath =>
                          [...prevFilePath, {
                            id: 0,
                            fileName: `${baseURL}vehicleClassFile/Get?name=${imageFilePath}`
                          }]
                        );
                      }
                    })

                    setWebsiteShowWebcam(false);
                  }
                }}
              >
                Capture an Image
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      <CustomImagePopup
        showPopup={websiteImagePopup}
        handlePopup={() => setWebsiteImagePopup(false)}
        filePath={websiteFilePath}
        fileIndex={fileIndex}
        setFileIndex={setFileIndex}
        imageBaseUrlPath="vehicleClassFile"
        updateFile={updateWebsiteFile}
      />


      <PleaseWaitPopup pleaseWaitPopup={pleaseWaitPopup} />
    </>
  )
}
